import type { ReactNode } from 'react'

import './form.css'

/**
 * 검색 툴바 — 와이어프레임 `.atool` CSS 473행. 목록 화면 뼈대의 한 줄이다(§14-1).
 *
 * 「작업 준비」 목록은 분류 칩(하위 탭 줄)을 검색 왼쪽에 넣고, 툴바째 준비 탭 줄 오른쪽에 선다
 * (`ListPage.toolbarInTabs` · eric 2026-10-06). 좁으면 접힌다 — 가로 스크롤은 없다(form.css).
 */
export type ToolbarProps = {
  children: ReactNode
  /** 접근성 이름 */
  label: string
}

export function Toolbar({ children, label }: ToolbarProps) {
  return (
    <div aria-label={label} className="a-toolbar" role="search">
      {children}
    </div>
  )
}
